import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'

import './impressum.scss'

function Impressum() {
  const { t } = useTranslation()

  useEffect(() => {
    document.title = 'Impressum | Dwain'
  }, [])

  return (
    <main className='page-impressum'>
      <article className='impressum-content'>
        <header className='content-header'>
          <h1 className='header-title'>{t('impressum.title')}</h1>
        </header>

        <section className='content-section'>
          <h2>{t('impressum.contact.title')}</h2>
          <address>
            Dwain Reinert<br />
            Turfstr 16<br />
            45899 Gelsenkirchen<br />
            <br />
            E-Mail: <a href="mailto:info@dwain.info">info@dwain.info</a>
          </address>
        </section>

        <section className='content-section'>
          <h2>{t('impressum.disclaimer.title')}</h2>
          <p>{t('impressum.disclaimer.content')}</p>
        </section>

        <section className='content-section'>
          <h2>{t('impressum.copyright.title')}</h2>
          <p>{t('impressum.copyright.content')}</p>
        </section>
      </article>
    </main>
  )
}

export default Impressum
